import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import {TextUtils} from '../../utils/text_utils';
import {DeactivatedIcon} from '../../icons/deactivated-icon';

// searchString and value is used by nested Dropdown
// eslint-disable-next-line no-unused-vars
export const Hexagon = ({searchString, value, text, imgUrl, active, children, intl, cy}) => {
	return (
		<Container data-cy={cy}>
			<HexagonContainer title={text}>
				{imgUrl ? (
					<Image crossOrigin="use-credentials" data-private src={imgUrl} />
				) : (
					<HexagonImg className="SMALL initials">{TextUtils.getInitials(text)}</HexagonImg>
				)}
			</HexagonContainer>
			{children}
			{active === false && <DeactivatedIcon intl={intl} />}
		</Container>
	);
};

Hexagon.propTypes = {
	text: PropTypes.string.isRequired,
	subText: PropTypes.string,
	imgUrl: PropTypes.string,
	searchString: PropTypes.string,
	cy: PropTypes.string,
	value: PropTypes.any,
	active: PropTypes.bool,
	intl: PropTypes.any,
	children: PropTypes.any,
};

Hexagon.defaultProps = {
	color: '#470c93',
};

export const Container = Styled.div`
	background-color: transparent;
	display: flex;
	flex-direction: row;
	padding: 5px 0;
	align-items: center;
	/* max-width: 100%; */
	height: 36px;
`;

const HexagonContainer = Styled.div`
	
	width: 28px;
	display: flex;
	justify-content: center;
	align-items: center;
`;

const Image = Styled.img`
	height: 26px;
`;
const HexagonImg = Styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 11px;

	position: relative;
	background-color: ${props => props.theme.colors.forecastPurple};
	text-transform: uppercase;
	color: white;
	
	&:before,
	&:after {
		content: '';
		position: absolute;
		width: 0;
		left: 0px;
		border-left: 12.5px solid transparent;
		border-right: 12.5px solid transparent;
	}

	&:before {
		bottom: 100%;
		border-bottom: ${props => `7.22px solid ${props.theme.colors.forecastPurple}`};
	}

	&:after {
		top: 100%;
		width: 0;
		border-top: ${props => `7.22px solid ${props.theme.colors.forecastPurple}`};
	}
	&.EXTRA_SMALL {
		width: 21px;
		height: 12.12px;
		margin: 6.06px 0;
		&:before,
		&:after {
			border-left: 10.5px solid transparent;
			border-right: 10.5px solid transparent;
		}
		&:before {
			border-bottom: ${props => `6.06px solid ${props.theme.colors.forecastPurple}`};
		}
		&:after {
			border-top: ${props => `6.06px solid ${props.theme.colors.forecastPurple}`};
		}
		.initials {
			font-size: 9px;
		}
	}
	&.SMALL {
		width: 23px;
		height: 13.28px;
		margin-right: 5px;
		&:before,
		&:after {
			border-left: 11.5px solid transparent;
			border-right: 11.5px solid transparent;
		}
		&:before {
			border-bottom: ${props => `6.64px solid ${props.theme.colors.forecastPurple}`};
		}
		&:after {
			border-top: ${props => `6.64px solid ${props.theme.colors.forecastPurple}`};
		}
		.initials {
			font-size: 10px;
		}
	}

`;
